<template lang="html">
  <div class="circle">
    <div class="content" v-if="topicPostList.length > 0 || threadList.length > 0">
      <div v-for="a in topicPostList" :key="a.topicid" class="threadCon" >
        <div v-show="a.type == 1" @click="goTopic(a.id)">
          <div class="userName">
            <div class="userImg">
              <img :src="a.avatar" alt="" class="userHeadPortrait">
              <img src="@/assets/image/icon/pv.png" alt="" class="userMark" v-if="a.mp_type == 1">
              <img src="@/assets/image/icon/tv.png" alt="" class="userMark" v-if="a.mp_type == 2">
            </div>
            <p>
              <span>{{a.username}}</span>
              <span>·</span>
              <span>
                发布的话题
              </span>
            </p>
          </div>
          <div v-if="a.images.length > 0" class="titleModel">
            <div>
              <p class="userTitle">{{a.title}}</p>
            </div>
            <img :src="a.images[0]" alt="">
          </div>
          <div v-else class="elseTitleModel">
            <p class="userTitle">{{a.title}}</p>
          </div>
          <div class="timeModel">
            <p class="userTime">{{a.date}}</p>
            <div class="hotModel">
              <div class="hotModelChild">
                <p class="hotNum">{{a.following_num}}</p>
                <p class="hotTxt">关注</p>
              </div>
              <div class="hotModelChild">
                <p class="hotNum">{{a.joinnumber}}</p>
                <p class="hotTxt">参与</p>
              </div>
              <div class="hotModelChild">
                <p class="hotNum">{{a.viewnumber}}</p>
                <p class="hotTxt">浏览</p>
              </div>
            </div>
          </div>
        </div>
        
        <div v-show="a.type == 2" @click="goTopicPost(a.id)">
          <p class="userTitle">{{a.title}}</p>
          <div class="userName">
            <div class="userImg">
              <img :src="a.avatar" alt="" class="userHeadPortrait">
              <img src="@/assets/image/icon/pv.png" alt="" class="userMark" v-if="a.mp_type == 1">
              <img src="@/assets/image/icon/tv.png" alt="" class="userMark" v-if="a.mp_type == 2">
            </div>
            <p>
              <span>{{a.username}}</span>
              <span>·</span>
              <span v-show="a.type == 2">
                参与的话题
              </span>
            </p>
          </div>
          <div v-if="a.images.length > 0" class="titleModel">
            <div>
              <p class="userContent" v-html="srtText(a.content)"></p>
            </div>
            <img :src="a.images[0]" alt="">
          </div>
          <div v-else class="elseTitleModel">
            <p class="userContent" v-html="srtText(a.content)"></p>
          </div>
          <div class="timeModel">
            <p class="userTime">{{a.date}}</p>
            <div class="hotModel" v-show="a.type == 2">
              <div class="hotModelChild"><img src="@/assets/image/icon/browse.png" alt=""><span>{{a.view_number}}</span></div>
              <div class="hotModelChild"><img src="@/assets/image/icon/reply.png" alt=""><span>{{a.comment_number}}</span></div>
              <div class="hotModelChild"><img src="@/assets/image/icon/praise.png" alt=""><span>{{a.like_number}}</span></div>
            </div>
          </div>
        </div>
      </div>
      
      <div v-for="b in threadList" :key="b.topicid" class="threadCon" @click="goInvitation(b.topicid)">
        <div class="userName">
          <div class="userImg">
            <img :src="b.avatar" alt="" class="userHeadPortrait">
            <img src="@/assets/image/icon/pv.png" alt="" class="userMark" v-if="b.mp_type == 2">
            <img src="@/assets/image/icon/tv.png" alt="" class="userMark" v-if="b.mp_type == 1">
          </div>
          <p>{{b.author}}</p>
        </div>
        <div class="elseTitleModel">
          <p class="userTitle">{{b.title}}</p>
          <p class="userContent">{{b.content}}</p>
        </div>
        <div class="timeModel">
          <p class="userTime">{{b.show_time}}</p>
          <div class="hotModel">
            <div class="hotModelChild"><img src="@/assets/image/icon/browse.png" alt=""><span>{{b.views}}</span></div>
            <div class="hotModelChild"><img src="@/assets/image/icon/reply.png" alt=""><span>{{b.replies}}</span></div>
            <div class="hotModelChild"><img src="@/assets/image/icon/praise.png" alt=""><span>{{b.show_marker}}</span></div>
          </div>
        </div>
      </div>     
    </div>

    <div class="noInfo" v-else>
      <div>
        <img :src="`${pagebase}/static/img/elecom/circle.png`" alt="">
      </div>
      <p>还没有任何圈子内容哦</p>
    </div>
  </div>
</template>

<script>
  import {pagebase} from '@/utils/http'
  
  export default {
    props: ['userId'],

    data() {
      return {
        threadList: [],
        topicPostList: [],
        pagebase: pagebase,
      }
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.getMyThreadList();
        this.getMyTopicPostList();
      },

      getMyThreadList() {
        this.$http({
          url: '/eleom/myThreadList',
          method: 'get',
          params: {
            start: 0,
            limit: 5,
            master_id: this.userId,
          }
        }).then(res => {
          if (res.code >= 0) {
            this.threadList = res.data;
          }
        })
      },
      
      getMyTopicPostList() {
        this.$http({
          url: '/eleom/myTopicPostList',
          method: 'get',
          params: {
            token: '',
            page: 1,
            master_id: this.userId,
          }
        }).then(res => {
          if (res.code >= 0) {
            this.topicPostList = res.data;
          }
        })
      },
      
      srtText(data){
        let text = data.replace(/<.*?>/g, "");
        return text;
      },
      
      goTopic(tid){
        sessionStorage.setItem('cur', 4);
        this.$router.push({
          path: '/topic',
          query: {
            tid: tid,
          }
        })
      },
      
      goTopicPost(tid){
        sessionStorage.setItem('cur', 4);
        this.$router.push({
          path: '/topicPost',
          query: {
            tid: tid,
          }
        })
      },
      
      goInvitation(tid){
        sessionStorage.setItem('cur', 4);
        this.$router.push({
          path: '/invitation',
          query: {
            tid: tid,
          }
        })
      }
    },
  }
</script>

<style lang="css" scoped>
  .circle {
    background-color: #F7F8F8;
  }

  .threadCon {
    box-sizing: border-box;
    margin-bottom: .8rem;
    background-color: #FFFFFF;
    padding: 1.5rem;
    position: relative;
  }

  .userName {
    display: flex;
    align-items: center;
    color: #3F454B;
    font-size: 12px;
  }

  .userImg {
    position: relative;
  }

  .userHeadPortrait {
    width: 3.4rem;
    height: 3.4rem;
    border-radius: 50%;
  }

  .userMark {
    position: absolute;
    left: 2.2rem;
    bottom: 0;
    width: 1.2rem;
    height: 1.2rem;
  }

  .userName p {
    margin-left: .8rem;
    font-size: 1.4rem;
    color: #606972;
  }
  
  .titleModel {
    display: flex;
    justify-content: space-between;
    margin-top: .7rem;
  }
  .titleModel div{
    width: 23.7rem;
  }
  
  .titleModel img{
    width: 10rem;
    height: 6.3rem;
    margin-left: .8rem;
    border-radius: .5rem;
    object-fit: cover;
  }
  
  .elseTitleModel {
    margin-top: .7rem;
  }

  .userTitle {
    margin-bottom: 1rem;
    font-size: 1.6rem;
    color: #1D2023;
    font-weight: 600;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .userContent {
    height: 3.8rem;
    font-size: 1.4rem;
    color: #606972;
    overflow: hidden;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .timeModel {
    display: flex;
    justify-content: space-between;
    margin-top: 1.5rem;
  }
  
  .userTime{
    font-size: 1.2rem;
    color: #C0C4CC;
  }

  .hotModel {
    display: flex;
  }

  .hotModelChild {
    width: 6rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .hotModelChild img {
    width: 1.9rem;
  }
  
  .hotModelChild span{
    font-size: 1.2rem;
    color: #C0C4CC;
    margin-left: .25rem;
  }
  
  .hotNum {
    font-size: 1.2rem;
    color: #1D2023;
    margin-right: .5rem;
  }
  
  .hotTxt{
    font-size: 1.2rem;
    color: #C0C4CC;
  }
  
  .noInfo {
    height: 37.5rem;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
  
  .noInfo img {
    width: 19.5rem;
    height: 19.5rem;
  }
  
  .noInfo p {
    font-size: 1.4rem;
    color: #9CA3A9;
  }
</style>
